import { useAppState } from "@/contexts/AppStateContext";
import "./Instructions.css";
import { useValidate } from "@/hooks/useValidation";
import { useEffect } from "react";
export type IrisStatus = 'open' | 'shrink' | 'transparent';
type InstructionsProps = {
  appState?: string;
  imageSrc?: string;
  imageAlt?: string;
  status?: IrisStatus;
};

export const Instructions = ({ appState: propAppState, imageSrc }: InstructionsProps) => {
  const { lambdaWarmUp } = useValidate();
  const { appState: contextAppState, setAppState } = useAppState();
  const appState = propAppState || contextAppState; // Use propAppState if provided, otherwise use contextAppState
  const guideImgSrc = imageSrc || "/images/Digi.png"; // Use prop imageSrc or fallback to default
  const innerStatus = ["instructions"].includes(appState) ? "show" : "";

  // Warm up the lambda on component mount
  useEffect(() => { lambdaWarmUp(); }, [lambdaWarmUp])

  return (
    <div
      className="instructions flex flex-col flex-1 w-full items-center bg-background text-white font-['FoundersGroteskMonoRegular']"
      data-testid="instruction-container"
    >
      {innerStatus === "show" && (
        <div className="flex flex-col items-center justify-center w-full mx-auto h-full">
            <div className="flex-1 flex flex-col items-end justify-center">
                  <h2 className="text-xl md:text-xl text-center text-white font-[FoundersGroteskMonoRegular] w-full flex flex-col gap-4 justify-center items-center">
                    <p>Hold camera over Digi H010 code</p>
                  </h2>
            <div className="flex flex-col justify-center items-center w-full mt-4">
              <img 
                src={guideImgSrc} 
                alt="Digi instructions"
                className="h-[300px] w-auto md:h-96 md:w-auto"/>
            </div>
          </div>
          <div className="flex-1 flex flex-col items-center w-full mt-10">
            <button
              data-testid="get-started-button"
              className="bg-white text-md text-black font-bold py-3 px-10 font-[FoundersGroteskMonoRegular] rounded-3xl "
              onClick={() => setAppState("playing")}
            >
              Scan
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
